<template>
    <div>
     <div v-if="loading" class="text-center py-3"><i class="fas fa-spinner fa-spin fa-2x"></i></div>

        <div v-else class="card shadow property mt-3">
        <div class="card-body pt-3 pb-4 px-4">

        <h5 class="title">{{ property.bedrooms }} bedroom {{ property.property_type.name }} for {{ property.category }} in {{ property.suburb.name }}</h5>
        <h4 class="price mb-2">R {{ formatCurrency(property.price) }} <span class="per-month" v-if="property.price_per && property.category=='rent'">p/{{property.price_per.toLowerCase()}}</span></h4>

      <b-carousel
      v-if="property.images.length > 0" 
      id="carousel-1"
      v-model="slide"
      :interval="6000"
      controls
      indicators
      background="#ababab"
      img-width="1024"
      img-height="480"
      style="text-shadow: 1px 1px 2px #333;"
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd">

      <b-carousel-slide
        v-for="image in property.images"
        :key="image.id"
        :img-src="image.url">
        
      </b-carousel-slide>

      </b-carousel>

      <img v-else class="property-thumbnail" :src="default_image">
        
        <div class="address mt-3">
          
          <span v-if="property.province">{{property.province.name}}</span>
          <span v-if="property.city"><span v-if="property.city.name !='Unknown'"> • {{property.city.name}}</span></span>
          <span v-if="property.suburb"> • {{property.suburb.name}}</span>
          <span :title="createdFormat"> • Listed <timeago :datetime="property.created_at" :auto-update="60"></timeago></span>
          <!-- <span v-if="property.complex_name">{{property.complex_name}}</span> 
          <span v-if="property.unit_number">{{property.unit_number}}, </span>
          <span v-if="property.street_number">{{property.street_number}} </span>
          <span v-if="property.street_name">{{property.street_name}}, </span> -->
          </div>
        <div class="available mt-3" v-if="property.available_from">Available from {{ property.available_from | moment("D MMMM YYYY") }}</div>

<table width="100%" border="0" cellspacing="0" cellpadding="0" class="mt-2">
  <tr>
    <td title="Bedrooms"><div class="icon"><i class="fas fa-bed"></i></div> {{property.bedrooms}}</td>
    <td title="Bathrooms"><div class="icon"><i class="fas fa-bath"></i></div> {{property.bathrooms}}</td>
  </tr>
</table>

        <hr>
        <div v-html="property.description" v-linkified class="description mt-3" style="white-space: pre-wrap;" />

                  </div>

        </div>

    </div>
        
</template>

<script>
import moment from 'moment'

export default {
props: ['property_id','user'],

  data() {
    return {
      property: {},
      loading: false,
      slide: 0,
      updating: false,
      userInfo: {},
      sliding: null,
      reason: '',
      default_image: 'https://property64.s3.af-south-1.amazonaws.com/images/image-not-found-1280x820.png',
      created: ''
    };
  },

  created() {

    this.getPropertyInfo();
    if (this.user) this.userInfo = JSON.parse(this.user);
   
  },

  methods: {


    onSlideStart(slide) {
        this.sliding = true
      },
      onSlideEnd(slide) {
        this.sliding = false
      },

    getPropertyInfo() {

      this.loading = true;

      axios.get("/products/getinfo/"+this.property_id)
           .then((response) => {
        this.property = response.data;
        this.createdFormat = this.formatDateSimple(this.property.created_at);
        this.loading = false;
      });
    },

  }

}

</script>

<style scoped>


div.address { color: #555; }
div.icon {width:20px;float:left;margin-right:10px;}
img.property-thumbnail {
  width: 100%;
}
div.available {
  font-size: 1rem;
  margin-bottom: 0.5rem;
  font-weight: bold;
}
h5.key {
  font-size: 1rem;
  margin-bottom: 0;
  font-weight: bold;
}
h5.title {
  font-size: 1.4rem;
  margin-bottom: 0;
  font-weight: bold;
}
h5.contact {
  font-size: 1.1rem;
  margin-bottom: 0;
  font-weight: bold;
}
h4.price{color: #09b3e7; font-weight: bold; margin-bottom: 0;font-size: 1.4rem;}
span.per-month{font-size: 1.1rem; color: black; font-weight: normal;}

</style>